module.exports = __webpack_public_path__ + "static/media/Bumppy Payments2.e062eb8e.png";